<div class="ap-modal">

  <!-- ── Header animé ──────────────────────────────────────────── -->
  <div class="ap-header">
    <div class="ap-header__orb ap-header__orb--1"></div>
    <div class="ap-header__orb ap-header__orb--2"></div>
    <div class="ap-header__orb ap-header__orb--3"></div>
    <div class="ap-header__icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
      </svg>
    </div>
    <div class="ap-header__text">
      <h2 class="ap-header__title">{{ data.titre }}</h2>
      <p class="ap-header__sub">Renseignez les caractéristiques avant calcul du prix</p>
    </div>
    <button type="button" class="ap-header__close" mat-dialog-close aria-label="Fermer">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <mat-dialog-content class="ap-body">
    <form [formGroup]="articleForm" (ngSubmit)="onSubmit()">
      <div *ngIf="!data.isViewMode" class="ap-content">

        <!-- ── ÉTAPE 1 : Formulaire ─────────────────────────────── -->
        <ng-container *ngIf="!prixCalcule">

          <!-- Badge étape -->
          <div class="ap-step-bar">
            <span class="ap-step-badge">
              <span class="ap-step-badge__num">1</span>
              <span class="ap-step-badge__label">Informations article</span>
            </span>
            <div class="ap-step-bar__line"></div>
            <span class="ap-step-badge ap-step-badge--next">
              <span class="ap-step-badge__num">2</span>
              <span class="ap-step-badge__label">Calcul du prix</span>
            </span>
          </div>

          <!-- Grille 4 colonnes : Type · Conditionnement · Quantité · Emballage -->
          <div class="ap-grid ap-grid--4">

            <div class="ap-field" style="--d:0ms">
              <label class="ap-field__label">Type d'article <span class="ap-req">*</span></label>
              <div class="ap-field__wrap">
                <span class="ap-field__ico">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
                </span>
                <select class="ap-field__input ap-field__input--sel"
                        formControlName="typeArticle"
                        (change)="onTypeArticleChanged($any($event.target).value)">
                  <option value="">Sélectionner…</option>
                  <option *ngFor="let ta of typeArticlesOptions" [value]="ta.value">{{ ta.label }}</option>
                </select>
              </div>
            </div>

            <div class="ap-field" style="--d:60ms">
              <label class="ap-field__label">Conditionnement <span class="ap-req">*</span></label>
              <div class="ap-field__wrap">
                <span class="ap-field__ico">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
                </span>
                <select class="ap-field__input ap-field__input--sel"
                        formControlName="typeConditionnement">
                  <option value="">Sélectionner…</option>
                  <option *ngFor="let tc of typeConditionnementOptions" [value]="tc.value">{{ tc.label }}</option>
                </select>
              </div>
            </div>

            <div class="ap-field" style="--d:120ms">
              <label class="ap-field__label">Quantité</label>
              <div class="ap-field__wrap">
                <span class="ap-field__ico">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </span>
                <input class="ap-field__input" type="text"
                       formControlName="quantite"
                       (keypress)="sharedUtilsService.numberOnly($event)"
                       (blur)="nettoyerNombre($event, 'quantite')"
                       placeholder="1" />
              </div>
            </div>

            <div class="ap-field ap-field--toggle" style="--d:180ms">
              <label class="ap-field__label">Emballage DEMATRAL</label>
              <label class="ap-toggle">
                <input type="checkbox" formControlName="flgEmballageDematral" />
                <span class="ap-toggle__track">
                  <span class="ap-toggle__thumb"></span>
                </span>
                <span class="ap-toggle__text">Activer</span>
              </label>
            </div>

          </div>

          <!-- Description + Valeur déclarée -->
          <div class="ap-grid ap-grid--desc">

            <div class="ap-field" style="--d:240ms">
              <label class="ap-field__label">Description</label>
              <div class="ap-field__wrap">
                <span class="ap-field__ico">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                </span>
                <input class="ap-field__input" type="text"
                       formControlName="description"
                       placeholder="Ex: Documents administratifs, Ordinateur portable…" />
              </div>
            </div>

            <div class="ap-field" style="--d:300ms">
              <label class="ap-field__label">Valeur Déclarée <span class="ap-field__unit">FCFA</span></label>
              <div class="ap-field__wrap">
                <span class="ap-field__ico">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                </span>
                <input class="ap-field__input" type="text"
                       formControlName="valeurDeclaree"
                       (keypress)="sharedUtilsService.numberOnly($event)"
                       (blur)="nettoyerNombre($event, 'valeurDeclaree')"
                       placeholder="0" />
              </div>
            </div>

          </div>

          <!-- Dimensions & Poids -->
          <div class="ap-dims-section" style="--d:360ms">
            <div class="ap-dims-section__header">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
              Dimensions &amp; Poids
            </div>
            <div class="ap-grid ap-grid--4">

              <div class="ap-field ap-field--dim" style="--d:400ms">
                <label class="ap-field__label">Longueur <span class="ap-field__unit">cm</span></label>
                <div class="ap-field__wrap">
                  <span class="ap-field__ico ap-field__ico--dim">L</span>
                  <input class="ap-field__input" type="text"
                         formControlName="longueur"
                         (keypress)="sharedUtilsService.numberOnly($event)"
                         (blur)="nettoyerNombre($event, 'longueur')"
                         (change)="prixCalcule = false"
                         placeholder="0" />
                </div>
              </div>

              <div class="ap-field ap-field--dim" style="--d:460ms">
                <label class="ap-field__label">Largeur <span class="ap-field__unit">cm</span></label>
                <div class="ap-field__wrap">
                  <span class="ap-field__ico ap-field__ico--dim">l</span>
                  <input class="ap-field__input" type="text"
                         formControlName="largeur"
                         (keypress)="sharedUtilsService.numberOnly($event)"
                         (blur)="nettoyerNombre($event, 'largeur')"
                         (change)="prixCalcule = false"
                         placeholder="0" />
                </div>
              </div>

              <div class="ap-field ap-field--dim" style="--d:520ms">
                <label class="ap-field__label">Hauteur <span class="ap-field__unit">cm</span></label>
                <div class="ap-field__wrap">
                  <span class="ap-field__ico ap-field__ico--dim">H</span>
                  <input class="ap-field__input" type="text"
                         formControlName="hauteur"
                         (keypress)="sharedUtilsService.numberOnly($event)"
                         (blur)="nettoyerNombre($event, 'hauteur')"
                         (change)="prixCalcule = false"
                         placeholder="0" />
                </div>
              </div>

              <div class="ap-field ap-field--dim" style="--d:580ms">
                <label class="ap-field__label">Poids <span class="ap-field__unit">kg</span></label>
                <div class="ap-field__wrap">
                  <span class="ap-field__ico ap-field__ico--dim">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="3"/><path d="M12 11v10M8 21h8"/></svg>
                  </span>
                  <input class="ap-field__input" type="text"
                         formControlName="poidsReel"
                         (keypress)="sharedUtilsService.numberOnly($event)"
                         (blur)="nettoyerNombre($event, 'poidsReel')"
                         (change)="prixCalcule = false"
                         placeholder="0" />
                </div>
              </div>

            </div>
          </div>

        </ng-container>

        <!-- ── ÉTAPE 2 : Récapitulatif du prix ────────────────────── -->
        <app-spinner *ngIf="loading"></app-spinner>

        <ng-container *ngIf="!loading && prixCalcule">

          <div class="ap-recap">

            <!-- ── Bannière article ──────────────────────────── -->
            <div class="ap-rc-header">
              <div class="ap-rc-header__left">
                <div class="ap-rc-header__icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                  </svg>
                </div>
                <div class="ap-rc-header__info">
                  <span class="ap-rc-header__type">{{ retournerLibelleDepuisClerEnum('TypeArticle') }}</span>
                  <span class="ap-rc-header__desc">{{ articleForm.value['description'] || '—' }}</span>
                </div>
              </div>
              <div class="ap-rc-header__tags">
                <span class="ap-rc-tag ap-rc-tag--purple">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="2" y="7" width="20" height="14" rx="2"/></svg>
                  {{ retournerLibelleDepuisClerEnum('TypeConditionnement') }}
                </span>
                <span class="ap-rc-tag ap-rc-tag--slate">
                  ×&nbsp;{{ articleForm.value['quantite'] }}
                </span>
                <span class="ap-rc-tag ap-rc-tag--green" *ngIf="articleForm.value['flgEmballageDematral']">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  Emballage
                </span>
                <span class="ap-rc-tag ap-rc-tag--amber" *ngIf="articleForm.value['valeurDeclaree'] > 0">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  {{ articleForm.value['valeurDeclaree'] | number }} FCFA
                </span>
              </div>
            </div>

            <!-- ── Analyse du poids ─────────────────────────── -->
            <div class="ap-rc-weights">
              <div class="ap-rc-weights__title">Analyse du poids</div>
              <div class="ap-rc-weights__row">

                <div class="ap-rc-w-card">
                  <div class="ap-rc-w-card__icon ap-rc-w-card__icon--blue">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="8" r="3"/><path d="M12 11v10M8 21h8"/></svg>
                  </div>
                  <div class="ap-rc-w-card__label">Poids réel</div>
                  <div class="ap-rc-w-card__val">{{ articleForm.value['poidsReel'] }}<span>kg</span></div>
                </div>

                <div class="ap-rc-w-sep">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                  <span>vs</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </div>

                <div class="ap-rc-w-card">
                  <div class="ap-rc-w-card__icon ap-rc-w-card__icon--slate">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
                  </div>
                  <div class="ap-rc-w-card__label">Poids vol.</div>
                  <div class="ap-rc-w-card__val">{{ articleForm.value['poidsVolumetrique'] || 0 }}<span>kg</span></div>
                </div>

                <div class="ap-rc-w-sep ap-rc-w-sep--accent">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </div>

                <div class="ap-rc-w-card ap-rc-w-card--winner">
                  <div class="ap-rc-w-card__icon ap-rc-w-card__icon--indigo">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div class="ap-rc-w-card__label">Retenu</div>
                  <div class="ap-rc-w-card__val">{{ articleForm.value['poids'] }}<span>kg</span></div>
                </div>

              </div>
            </div>

            <!-- ── Détail du calcul ─────────────────────────── -->
            <div class="ap-rc-breakdown">
              <div class="ap-rc-breakdown__title">Détail du prix</div>

              <div class="ap-rc-breakdown__lines">

                <div class="ap-rc-line" *ngIf="articleForm.value['longueurDuTrajet']">
                  <div class="ap-rc-line__icon ap-rc-line__icon--blue">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><path d="M12 5l7 7-7 7"/></svg>
                  </div>
                  <span class="ap-rc-line__label">Longueur du trajet</span>
                  <div class="ap-rc-line__dots"></div>
                  <span class="ap-rc-line__val">{{ articleForm.value['longueurDuTrajet'] }} km</span>
                </div>

                <div class="ap-rc-line" *ngIf="articleForm.value['montantForfait']">
                  <div class="ap-rc-line__icon ap-rc-line__icon--violet">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="2" y="4" width="20" height="16" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
                  </div>
                  <span class="ap-rc-line__label">Montant forfaitaire</span>
                  <div class="ap-rc-line__dots"></div>
                  <span class="ap-rc-line__val">{{ articleForm.value['montantForfait'] | number }} FCFA</span>
                </div>

                <div class="ap-rc-line ap-rc-line--warn" *ngIf="articleForm.value['montantSupplementaire'] > 0">
                  <div class="ap-rc-line__icon ap-rc-line__icon--orange">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </div>
                  <span class="ap-rc-line__label">Poids sup. ({{ articleForm.value['poidsSupplementaire'] }} kg)</span>
                  <div class="ap-rc-line__dots"></div>
                  <span class="ap-rc-line__val">+ {{ articleForm.value['montantSupplementaire'] | number }} FCFA</span>
                </div>

                <div class="ap-rc-line" *ngIf="articleForm.value['montantSupplementaire'] == 0 && articleForm.value['prixUnitaire']">
                  <div class="ap-rc-line__icon ap-rc-line__icon--green">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  </div>
                  <span class="ap-rc-line__label">Prix unitaire × {{ articleForm.value['quantite'] }}</span>
                  <div class="ap-rc-line__dots"></div>
                  <span class="ap-rc-line__val">{{ articleForm.value['prixUnitaire'] | number }} FCFA</span>
                </div>

              </div>
            </div>

            <!-- ── Total ────────────────────────────────────── -->
            <div class="ap-total-banner">
              <div class="ap-total-banner__orb"></div>
              <div class="ap-total-banner__left">
                <div class="ap-total-banner__icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
                </div>
                <div>
                  <div class="ap-total-banner__label">Montant article</div>
                  <div class="ap-total-banner__sub">Toutes taxes incluses</div>
                </div>
              </div>
              <div class="ap-total-banner__amount">
                {{ articleForm.value['montant'] | number }}
                <span>FCFA</span>
              </div>
            </div>

          </div>

        </ng-container>

        <!-- ── Actions ───────────────────────────────────────────── -->
        <div class="ap-actions" *ngIf="!loading">
          <button type="button" class="ap-btn ap-btn--cancel" mat-dialog-close>
            Annuler
          </button>
          <button type="button" class="ap-btn ap-btn--prev"
                  (click)="prixCalcule = false" *ngIf="prixCalcule">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            Précédent
          </button>
          <button type="submit" class="ap-btn ap-btn--primary" *ngIf="!prixCalcule">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            Calculer le Prix
          </button>
          <button type="button" class="ap-btn ap-btn--confirm"
                  (click)="ajouterArticle()" *ngIf="prixCalcule">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
            {{ data.typeOperation == 'mod' ? 'Enregistrer' : "Ajouter l'article" }}
          </button>
        </div>

      </div>
    </form>
  </mat-dialog-content>

</div>
